import { InputNumber } from 'antd';
import { DadosAreaConstruida } from '@/features/laudo/types/laudo-wizard.types';
import { formatarMoeda } from '../utils';
import * as styles from '../styles';
import type { DadosCalculados } from '../types';

export const createColumns = (
  dadosCalculados: DadosCalculados[],
  handleInputChange: (index: number, field: keyof DadosAreaConstruida, value: number) => void,
  disabled?: boolean,
  displayIdMap?: Record<string, string>
) => [
  {
    title: 'Identificação',
    dataIndex: 'identificacao',
    key: 'identificacao',
    width: 120,
    fixed: 'left' as const,
    render: (text: string) => {
      const label = displayIdMap?.[text] || text;
      return <strong style={{ color: text === 'Avaliando' ? '#1890ff' : '#000' }}>{label}</strong>;
    },
  },
  {
    title: 'Tipo',
    dataIndex: 'tipoImovel',
    key: 'tipoImovel',
    width: 110,
    render: (value: string) => <div style={styles.cellCenterStyle}>{value}</div>,
  },
  {
    title: 'Área Construída (m²)',
    dataIndex: 'areaConstruida',
    key: 'areaConstruida',
    width: 180,
    render: (value: number) => {
      const areaValue = Number(value || 0);
      return (
        <div
          style={{
            ...styles.cellCenterStyle,
            backgroundColor: '#fafafa',
            padding: '4px 8px',
            borderRadius: 4,
          }}
          title="Campo automático - vem dos Dados do Imóvel (Avaliando) ou das Amostras"
        >
          {areaValue.toFixed(2)} m²
        </div>
      );
    },
  },
  {
    title: 'CUB (R$/m²)',
    dataIndex: 'cubBase',
    key: 'cubBase',
    width: 160,
    render: (value: number, record: DadosAreaConstruida, index: number) => {
      const isApartamento = record.tipoImovel === 'Apartamento';

      if (isApartamento) {
        return (
          <div style={styles.cellReadonlyStyle} title="Apartamentos não usam CUB - valor calculado direto do anúncio">
            —
          </div>
        );
      }

      return (
        <InputNumber
          value={value}
          onChange={(newValue) => handleInputChange(index, 'cubBase', Number(newValue) || 0)}
          style={{ width: '100%' }}
          step={0.01}
          precision={2}
          addonBefore="R$"
          disabled={disabled ?? false}
        />
      );
    },
  },
  {
    title: 'Ajuste Padrão Acabamento',
    dataIndex: 'ajusteAcabamento',
    key: 'ajusteAcabamento',
    width: 200,
    render: (value: number, record: DadosAreaConstruida, index: number) => {
      const isApartamento = record.tipoImovel === 'Apartamento';

      if (isApartamento) {
        return (
          <div style={styles.cellReadonlyStyle} title="Apartamentos não usam ajuste - valor calculado direto do anúncio">
            —
          </div>
        );
      }

      return (
        <InputNumber
          value={value}
          onChange={(newValue) => handleInputChange(index, 'ajusteAcabamento', Number(newValue) || 0)}
          style={{ width: '100%' }}
          step={0.01}
          precision={2}
          decimalSeparator=","
          disabled={disabled ?? false}
        />
      );
    },
  },
  {
    title: 'Depreciação',
    dataIndex: 'depreciacao',
    key: 'depreciacao',
    width: 140,
    render: (value: number) => {
      const depValue = Number(value || 0);
      return (
        <div
          style={styles.cellReadonlyStyle}
          title="Valor calculado automaticamente pela Tabela de Depreciação"
        >
          {depValue.toFixed(3)}
        </div>
      );
    },
  },
  {
    title: 'CUB Ajustado (R$/m²)',
    dataIndex: 'cubAjustado',
    key: 'cubAjustado',
    width: 180,
    render: (_: any, __: DadosAreaConstruida, index: number) => {
      const itemCalculado = dadosCalculados[index];
      if (!itemCalculado) return null;
      return <div style={styles.cellHighlightBlueStyle}>{formatarMoeda(itemCalculado.cubAjustado)}</div>;
    },
  },
  {
    title: 'Valor Final (R$)',
    dataIndex: 'valorFinal',
    key: 'valorFinal',
    width: 180,
    render: (_: any, __: DadosAreaConstruida, index: number) => {
      const itemCalculado = dadosCalculados[index];
      if (!itemCalculado) return null;
      return <div style={styles.cellHighlightGreenStyle}>{formatarMoeda(itemCalculado.valorFinal)}</div>;
    },
  },
];
